import { useEffect, useState } from 'react';

import { getPageTitle } from '../../../components/PageLayout/utils';

interface TitleClaim {
  order: number;
  title: string;
}

let nextOrder = 0;
const claims: TitleClaim[] = [];

const applyTitle = () => {
  const latest = claims.reduce<TitleClaim | undefined>(
    (best, claim) => (!best || claim.order > best.order ? claim : best),
    undefined
  );
  document.title = latest?.title ?? getPageTitle();
};

/**
 * Names the browser tab while mounted. The innermost caller wins; unmounting or
 * passing `undefined` hands the tab back to the next caller out.
 */
const useDocumentTitle = (title: string | undefined) => {
  // Parents render before their children, so this orders callers outermost first
  const [order] = useState(() => nextOrder++);

  useEffect(() => {
    if (title === undefined) {
      return;
    }

    const claim = { order, title };
    claims.push(claim);
    applyTitle();

    return () => {
      claims.splice(claims.indexOf(claim), 1);
      applyTitle();
    };
  }, [order, title]);
};

export default useDocumentTitle;
